import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { BrowserStorageService } from '../../shared/services/common/browser-storage.service';
import { SafeHtmlPipe } from '../../shared/validators/safe-html.pipe';
import { ICONS } from '../../utils/svg-icons';

@Component({
  selector: 'app-tab-to-top',
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './tab-to-top.component.html',
  styleUrls: ['./tab-to-top.component.scss'],
})
export class TabToTopComponent implements OnInit {
  public show: boolean = false;
  ICONS = ICONS;
  constructor(
    private viewScroller: ViewportScroller,
    private browserService: BrowserStorageService,
  ) {}

  ngOnInit(): void {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    let number =
      this.browserService.getWindow().pageYOffset ||
      this.browserService.getDocument().documentElement.scrollTop ||
      this.browserService.getDocument().body.scrollTop ||
      0;
    if (number > 400) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  taptotop() {
    this.viewScroller.scrollToPosition([0, 0]);
  }
}
